<template>
  <span class="bottom-label__item">
    <span class="bottom-label__i--wrap">
      <app-icon :type="icon"></app-icon>
    </span><span>{{text}}</span>
  </span>
</template>
<script>
import AppIcon from '@/components/icon';
export default {
  props: {
    icon: String,
    text: String
  },
  components: {
    'app-icon': AppIcon
  }
};
</script>

<style lang="less">
@import '../../assets/css/common.less';
.bottom-label__item {
  display: inline-flex;
  align-items: center;
  height: 100px;
  .bottom-label__i--wrap {
    border-radius: 22px;
    border: 1px solid #E6E6E6;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 44px;
    height: 44px;
    i {
      color: #AE9C7D;
      font-size: 22px;
      font-weight: bold;
    }
  }
  span {
    font: normal bold 16px @family-nomal;
    margin-left: 1rem;
    color: @font-color-main
  }
}
</style>



// WEBPACK FOOTER //
// src/components/bottom/comp-label-item.vue